import { Box, TextField } from "@mui/material";
import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useLocation, useNavigate } from "react-router-dom";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../BusinessObjects/Redux/app/hook";
import { RootState } from "../../../BusinessObjects/Redux/app/store";
import { toggleDrawer } from "../../../BusinessObjects/Redux/features/app/appSlice";
import { RoutePath } from "../../../Utils/RoutePath";
import UserPanel from "../UserPanel/UserPanel";
import "./HeaderNavBar.css";
import { useScreenSize } from "../../../Hooks/useScreenSize";

type Props = {};

const HeaderNavBar = (props: Props) => {
  let location = useLocation();

  const drawerOpen = useAppSelector((state: RootState) => state.app.drawerOpen);
  const company = useAppSelector((state: RootState) => state.app.company);
  const isLoggedIn = useAppSelector(
    (state: RootState) => state.user.isLoggedIn
  );

  const { isXSmall } = useScreenSize();

  let navigate = useNavigate();

  let dispatch = useAppDispatch();

  if (!isLoggedIn) {
    return (
      <header
        id="appbar"
        className="login shadow-sm w-100 d-flex flex-row-reverse "
      >
        <div className="d-flex align-items-center" style={{ paddingRight: 30 }}>
          <h6>E-CUBE</h6>
        </div>
      </header>
    );
  }

  return (
    <header
      id="appbar"
      className="login shadow w-100 d-flex flex-row position-relative"
    >
      <div
        className={`d-flex align-items-center p-2 justify-content-center logo-container ${
          drawerOpen ? "open" : ""
        }`}
      >
        <LazyLoadImage
          src={
            drawerOpen
              ? `images/${company}/logo-bianco.png`
              : `images/${company}/small-logo-bianco.png`
          }
          alt={company}
          effect="blur"
          className="img-fluid cursor--pointer"
          onClick={() => {
            navigate(RoutePath.HOME + "?closeAllTabs=true");
          }}
          style={{
            maxWidth: drawerOpen ? 200 : 42,
            maxHeight: drawerOpen ? 50 : 42,
          }}
        />
      </div>
      {location.pathname === RoutePath.HOME ? (
        <div
          className="d-flex align-items-center menu-icon"
          style={{ paddingLeft: 30 }}
        >
          {drawerOpen ? (
            !isXSmall ? (
              <i
                className="fa-solid fa-arrow-left"
                onClick={(e) => {
                  e.preventDefault();
                  dispatch(toggleDrawer());
                }}
              />
            ) : null
          ) : (
            <i
              className="fa-solid fa-bars"
              onClick={(e) => {
                e.preventDefault();
                dispatch(toggleDrawer());
              }}
            />
          )}
        </div>
      ) : (
        <Box sx={{ flexGrow: 1 }} />
      )}
      <div
        className="position-absolute top-50 end-0 translate-middle-y"
        style={{ paddingRight: 30 }}
      >
        <UserPanel />
      </div>
    </header>
  );
};

export default HeaderNavBar;
